import axios from 'axios';

// Automatically picks up the current environment's API URL
const API_URL: string = process.env.NEXT_PUBLIC_API_URL!;
const WEB_API_URL: string = process.env.NEXT_PUBLIC_WEB_API_URL!;

//Get All Menu
export const getMenu = async(params: any)=>{
    return axios.post(`${API_URL}WebPreview/Get_Menu`,params).then((res)=>res.data).catch((error)=>{console.log("Get Menu error",error); throw error;})
}

//Get Category
export const getCategory = async(params: any)=>{
    return axios.post(`${API_URL}WebPreview/Get_Category`,params).then((res)=>res.data).catch((error)=>{console.log("Get Category error",error); throw error;})
}

//Member Login
export const memberLogin = async(params: any)=>{
    return axios.post(`${WEB_API_URL}sign/in`,params).then((res)=>res.data).catch((error)=>{console.log("Member Login error",error); throw error;})
}

//Member Zone Logout
export const memberLogout = async()=>{
    return axios.get(`${WEB_API_URL}Sign/Out`).then((res)=> res).catch((error)=>{console.log("Member Zone Sign Out Error",error);return error.response})
}

//Member Zone Status Verify
export const memberStatusVerify = async()=>{
    return axios.get(`${WEB_API_URL}Sign/Status_Verify`).then((res)=> res.data).catch((error)=>{console.log("Member Zone Status Verify Error",error); throw error;})
}

//Member Change Password
export const memberChangePW = async(params: any)=>{
    return axios.post(`${WEB_API_URL}Cservices/Upd_FS_B2B_Usr`,params).then((res)=>res.data).catch((error)=>{console.log("Member Change Password error",error); throw error;})
}

//Member Sales
export const getMemberSales = async(params: any)=>{
    return axios.post(`${WEB_API_URL}Cservices/C_Sales`,params).then((res)=>res.data).catch((error)=>{console.log("Get Member Sales error",error); throw error;})
}

//Member Get Invoice
export const getInvoiceDropdown = async(params: any)=>{
    return axios.post(`${WEB_API_URL}Cservices/Get_FS_B2B_Inv`,params).then((res)=>res.data).catch((error)=>{console.log("Get Invoice Dropdown error",error); throw error;})
}

//Member Download Invoice
export const downloadInvoice = async(params: any)=>{
    return axios.post(`${WEB_API_URL}Cservices/Get_FS_B2B_Inv`,params).then((res)=>res.data).catch((error)=>{console.log("Download Invoice error",error); throw error;})
}

//Oil Card Application Submit
export const submitOilCardApp = async(params: any)=>{
    return axios.post(`${WEB_API_URL}ComWeb/SubmitAppForm`,params).then((res)=>res.data).catch((error)=>{console.log("Oil Card Application Submit error",error); throw error;})
}

//Oil Card Application Upload Attachment
export const oilCardAppUploadAttachment = async(params: any)=>{
    return axios.post(`${WEB_API_URL}ComWeb/UploadAttachment`,params).then((res)=>res.data).catch((error)=>{console.log("Oil Card Application Upload Attachment error",error); throw error;})
}

//Oil Card Application Complete Upload
export const oilCardAppCompleteUpload = async(params: any)=>{
    return axios.post(`${WEB_API_URL}ComWeb/CompleteUploadSequence`,params).then((res)=>res.data).catch((error)=>{console.log("Oil Card Application Complete Upload error",error); throw error;})
}

//Oil Card Application Form Submit
export const submitOilCardApplicationForm = async(params: any)=>{
    return axios.post(`${WEB_API_URL}ComWeb/SubmitOilCardApp`,params).then((res)=>res.data).catch((error)=>{console.log("Oil Card Application Form Submit error",error); throw error;})
}

//Contact Us Form Submit
export const submitContactUs = async(params: any)=>{
    return axios.post(`${WEB_API_URL}ComWeb/SubmitContactUs`,params).then((res)=>res.data).catch((error)=>{console.log("Contact Us submit error",error); throw error;})
}